import isPlainObject from './isPlainObject';
import isMap from './isMap';
import hasGeneratorInterface from './hasGeneratorInterface';
import flattenWhenNode from './flattenWhenNode';

export default flattenWhenNode(function (node) {
  return (isPlainObject(node) || isMap(node)) && !hasGeneratorInterface(node);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/flattenReducerMap.js
// module id = ./node_modules/redux-actions/es/utils/flattenReducerMap.js
// module chunks = 6 9 11